export const RATE = 0.00055;
